import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left accessibility-key-feature-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "key-features-of-adobe-pdf-accessibility-auto-tag-api"
    }}>{`Key features of Adobe PDF Accessibility Auto-Tag API`}</h2>
    <TextBlock slots="image, heading, text" width="25%" theme="light" className="align-left iocn-size  horizontal-align-heading Benefits-one" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/bba29ffae164f19fa7b4a70244743921/autoTagKeyFOne.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "highly-accurate-content-tagging"
    }}>{`Highly accurate content tagging`}</h3>
    <p>{`Automatically tag tables, paragraphs, lists, and headings to improve the reading experience of native and scanned PDFs with assistive technologies.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="light" className="align-left iocn-size  horizontal-align-heading Benefits-two" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/4c3d6dcd9337c435fc4f703d25addcdb/readingOrder.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "reading-order-identification"
    }}>{`Reading order identification`}</h3>
    <p>{`Identify the logical flow of information, even with multiple columns and elements across multiple pages.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="light" className="align-left iocn-size  link horizontal-align-heading linking Benefits-three" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/66e4e9a03dca4320aaaccafcbd55cf3a/wideRange.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "wide-range-of-doc-types-at-scale"
    }}>{`Wide range of doc types, at scale`}</h3>
    <p>{`Apply at scale to large backlogs or add to automated workflows, including long-form text and mixed-content documents across various languages.`}</p>
    <TextBlock slots="image, heading, text" width="25%" theme="light" className="align-left iocn-size  link horizontal-align-heading linking Benefits-four" mdxType="TextBlock" />
    <p><img parentName="p" {...{
        "src": "/document-services/assets/c977e004ee4b4a3517338ff14089b2f1/tailoredTagging.svg",
        "alt": "EMPTY_ALT"
      }}></img></p>
    <h3 {...{
      "id": "tailored-tagging-report"
    }}>{`Tailored tagging report`}</h3>
    <p>{`Review a generated Microsoft Excel report detailing the tags that were replaced, if any, the newly added tags, and any content that needs additional review.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      